// Mock data for J Class Motors - Luxury Sports Car Dealership

export const mockCars = [
  {
    id: 1,
    make: "פרארי",
    model: "488 GTB",
    year: 2023,
    price: 1850000,
    mileage: 2500,
    condition: "כמו חדש",
    color: "אדום מטאלי",
    engine: "3.9L V8 Twin Turbo",
    power: "670 כ\"ס",
    transmission: "אוטומטי 7 הילוכים",
    fuelType: "בנזין",
    images: [
      "https://images.unsplash.com/photo-1622945772259-d25c5a437f47?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBzcG9ydHMlMjBjYXJzfGVufDB8fHx8MTc1ODAzMDE1N3ww&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1579859273605-8fc8208cd578?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBzcG9ydHMlMjBjYXJzfGVufDB8fHx8MTc1ODAzMDE1N3ww&ixlib=rb-4.1.0&q=85"
    ],
    features: ["מערכת ניווט GPS", "מושבי עור איטלקי", "מערכת שמע פרימיום", "בקרת אקלים אוטומטי", "מצלמת רוורס"],
    description: "פרארי 488 GTB מהמהירות הגבוהה ביותר עם ביצועים יוצאי דופן ועיצוב איטלקי קלאסי."
  },
  {
    id: 2,
    make: "למבורגיני",
    model: "Huracán EVO",
    year: 2024,
    price: 2200000,
    mileage: 850,
    condition: "חדש",
    color: "לבן פנינה",
    engine: "5.2L V10",
    power: "630 כ\"ס",
    transmission: "אוטומטי 7 הילוכים",
    fuelType: "בנזין",
    images: [
      "https://images.unsplash.com/photo-1742056024244-02a093dae0b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBzcG9ydHMlMjBjYXJzfGVufDB8fHx8MTc1ODAzMDE1N3ww&ixlib=rb-4.1.0&q=85",
      "https://images.pexels.com/photos/18818786/pexels-photo-18818786.jpeg"
    ],
    features: ["מערכת ALA פעילה", "מצגת דיגיטלית TFT", "מערכת בטיחות מתקדמת", "מצב נהיגה דינמית", "גגון קרבון"],
    description: "למבורגיני הוראקן EVO - שילוב מושלם של עוצמה, יוקרה וטכנולוגיה מתקדמת."
  },
  {
    id: 3,
    make: "BMW",
    model: "M3 Competition",
    year: 2023,
    price: 580000,
    mileage: 8200,
    condition: "מצוין",
    color: "שחור מטאלי",
    engine: "3.0L Twin Turbo I6",
    power: "510 כ\"ס",
    transmission: "אוטומטי 8 הילוכים",
    fuelType: "בנזין",
    images: [
      "https://images.unsplash.com/photo-1579859273605-8fc8208cd578?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBzcG9ydHMlMjBjYXJzfGVufDB8fHx8MTc1ODAzMDE1N3ww&ixlib=rb-4.1.0&q=85",
      "https://images.pexels.com/photos/25286626/pexels-photo-25286626.jpeg"
    ],
    features: ["מערכת M xDrive", "בלמי קרבון", "מושבי M Sport", "מערכת שמע Harman Kardon", "מצב Track"],
    description: "BMW M3 Competition - ביצועי מרוץ עם נוחות יומיומית ברמה הגבוהה ביותר."
  },
  {
    id: 4,
    make: "פורשה",
    model: "911 Turbo S",
    year: 2024,
    price: 1650000,
    mileage: 1200,
    condition: "כמו חדש",
    color: "כסף מטאלי",
    engine: "3.8L Twin Turbo Flat-6",
    power: "650 כ\"ס",
    transmission: "PDK אוטומטי 8 הילוכים",
    fuelType: "בנזין",
    images: [
      "https://images.unsplash.com/photo-1692406069831-0bb7ea297645?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxjYXIlMjBzaG93cm9vbXxlbnwwfHx8fDE3NTgwMzAxNjh8MA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1644749700856-a82a92828a1b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxjYXIlMjBzaG93cm9vbXxlbnwwfHx8fDE3NTgwMzAxNjh8MA&ixlib=rb-4.1.0&q=85"
    ],
    features: ["מערכת PASM פעילה", "מושבי ספורט Plus", "מערכת PCM מתקדמת", "גגון פנורמי", "מטען אלחוטי"],
    description: "פורשה 911 טורבו S - האבולוציה האחרונה של האייקון הגרמני המפורסם."
  },
  {
    id: 5,
    make: "מקלארן",
    model: "720S",
    year: 2023,
    price: 2400000,
    mileage: 3100,
    condition: "מצוין",
    color: "כתום מטאלי",
    engine: "4.0L V8 Twin Turbo",
    power: "720 כ\"ס",
    transmission: "אוטומטי 7 הילוכים",
    fuelType: "בנזין",
    images: [
      "https://images.unsplash.com/photo-1622046120199-32f27980473d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxjYXIlMjBzaG93cm9vbXxlbnwwfHx8fDE3NTgwMzAxNjh8MA&ixlib=rb-4.1.0&q=85",
      "https://images.pexels.com/photos/25286626/pexels-photo-25286626.jpeg"
    ],
    features: ["דלתות פרפר", "שלדת קרבון", "מערכת הפעלה ProActive", "מושבי מרוץ", "מערכת ניווט 3D"],
    description: "מקלארן 720S - סופרקאר עם טכנולוגיית מרוץ ועיצוב עתידני חסר פשרות."
  },
  {
    id: 6,
    make: "אסטון מרטין",
    model: "DB11",
    year: 2023,
    price: 1950000,
    mileage: 4500,
    condition: "מצוין",
    color: "כחול מטאלי",
    engine: "5.2L V12 Twin Turbo",
    power: "630 כ\"ס",
    transmission: "אוטומטי 8 הילוכים",
    fuelType: "בנזין",
    images: [
      "https://images.unsplash.com/photo-1622945772259-d25c5a437f47?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBzcG9ydHMlMjBjYXJzfGVufDB8fHx8MTc1ODAzMDE1N3ww&ixlib=rb-4.1.0&q=85",
      "https://images.pexels.com/photos/18818786/pexels-photo-18818786.jpeg"
    ],
    features: ["עור Hand-stitched", "מערכת שמע Bang & Olufsen", "גגון קרבון", "מצב GT/Sport", "מערכת בטיחות מתקדמת"],
    description: "אסטון מרטין DB11 - הגדרה מחדש של יוקרה בריטית עם ביצועים יוצאי דופן."
  }
];

export const mockServices = [
  {
    id: 1,
    title: "קנייה ומכירה",
    description: "מתמחים ברכישה ומכירה של רכבי יוקרה וספורט ברמה הגבוהה ביותר",
    icon: "car",
    features: ["הערכת שווי מקצועית", "ליווי מקצועי בתהליך", "בדיקות טכניות מקיפות", "ייעוץ אישי"]
  },
  {
    id: 2,
    title: "החלפת רכבים",
    description: "שירותי טרייד-אין מתקדמים עם הערכת שווי הוגנת ומקצועית",
    icon: "refresh",
    features: ["הערכת שווי מיידית", "עסקאות שקופות", "תהליך מהיר ויעיل", "ייעוץ פיננסי"]
  },
  {
    id: 3,
    title: "טיפוח ואחזקה",
    description: "שירותי טיפוח ואחזקה מקצועיים לרכבי יוקרה וספורט",
    icon: "wrench",
    features: ["דיטיילינג מקצועי", "אחזקה מונעת", "חלפים מקוריים", "טכנאים מוסמכים"]
  }
];

export const mockTestimonials = [
  {
    id: 1,
    name: "דוד כהן",
    text: "שירות יוצא דופן! רכשתי פרארי 488 ואני מרוצה מכל שלב בתהליך. מקצועיות ברמה הגבוהה ביותר.",
    rating: 5,
    car: "פרארי 488 GTB"
  },
  {
    id: 2,
    name: "מיכל לוי",
    text: "החלפתי את הרכב שלי בלמבורגיני חדשה. התהליך היה חלק, מהיר ושקוף לחלוטין. ממליצה בחום!",
    rating: 5,
    car: "למבורגיני הוראקן"
  },
  {
    id: 3,
    name: "רון אברהם",
    text: "קיבלתי שירותי טיפוח למקלארן שלי. התוצאה מעבר לציפיות - הרכב נראה כמו חדש מהסלון!",
    rating: 5,
    car: "מקלארן 720S"
  }
];

export const mockCompanyInfo = {
  name: "J CLASS MOTORS",
  tagline: "יבוא, רכבי יוקרה, טרייד אין",
  phone: "058-7019669",
  email: "Jeromecarss@gmail.com",
  address: "חיים ארלוזורוב 50, נתניה",
  workingHours: "ראשון-חמישי: 09:00-18:00",
  whatsapp: "058-7019669",
  about: "J CLASS MOTORS היא סוכנות רכבים מובילה המתמחה ברכבי יוקרה וספורט. אנו מציעים מגוון שירותים כולל קנייה, מכירה, החלפת רכבים וטיפוח מקצועי. עם ניסיון רב שנים בתחום, אנו מתחייבים לספק שירות יוצא דופן ואמינות ללקוחותינו."
};